import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=cbe30fa2&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe30fa2",
  null
  
)

export default component.exports